import { Injectable } from '@angular/core';
import { countriesCdEnum } from '@shared/enums/countries-cd.enum';
import { LocationGetQueryModel, LocationModel, LocationResponseModel } from '@shared/models/location.model';
import { GetSicForPostalCodesQuery, GetSicForPostalCodesResp } from '@xpo-ltl-2.0/sdk-location';

@Injectable({
  providedIn: 'root'
})
export class LocationApiMapperService {

  constructor() { }

  getRequest(location: LocationModel): LocationGetQueryModel {
    const requestQuery = new LocationGetQueryModel();
    requestQuery.usCa = this.getUsCaRequest(location);
    requestQuery.mx = this.getMexicoRequest(location)

    return requestQuery;
  }

  getResponse(locationUsCaResp: GetSicForPostalCodesResp, locationMxResp: GetSicForPostalCodesResp): LocationResponseModel {    
    return {
      postalSicAssignments: [...locationUsCaResp?.postalSicAssignments || [], ...locationMxResp?.postalSicAssignments || []],
      validationErrors: [...locationUsCaResp?.validationErrors || [], ...locationMxResp?.validationErrors || []]
    }
  } 

  private getUsCaRequest(location: LocationModel): GetSicForPostalCodesQuery {
    const originLocation = location?.originLocation?.countryCode === countriesCdEnum.usCa ? location.originLocation : undefined;
    const destLocation = location?.destLocation?.countryCode === countriesCdEnum.usCa ? location.destLocation : undefined;

    if (!originLocation && !destLocation) return;

    const request = new GetSicForPostalCodesQuery();

    request.postalCds = [
      originLocation?.postalCode,
      originLocation?.postalCode !== destLocation?.postalCode ? destLocation?.postalCode : undefined
    ];

    return request;
  }

  private getMexicoRequest(location: LocationModel): GetSicForPostalCodesQuery {
    const originLocation = location?.originLocation?.countryCode === countriesCdEnum.mx ? location.originLocation : undefined;
    const destLocation = location?.destLocation?.countryCode === countriesCdEnum.mx ? location.destLocation : undefined;
    if (!originLocation && !destLocation) return;

    const request = new GetSicForPostalCodesQuery();

    request.postalCds = [ originLocation?.postalCode, destLocation?.postalCode ];
    request.countryCds = [ originLocation?.countryCode, destLocation?.countryCode ];

    return request;
  }
}
